import React, { useContext } from "react";
import { Route, useHistory, useLocation } from "react-router-dom";
import { Context } from "./Context";
import restrictedRoutes from "./restrictedRoutes";

export default function PrivateRoute({ component: Component, ...rest }) {
    const context = useContext(Context);
    const history = useHistory();
    const location = useLocation();

    let source = "/signIn";
    if (location.search) {
        const urlParams = new URLSearchParams(location.search);
        source = urlParams.get("source");
    }
    const redirectURl = source === "shopify" ? "/register" : "/signIn";

    const dashboardUrl = "/";

    const permissionsRequired = restrictedRoutes[rest.path];

    if (permissionsRequired) {
        for (const permission of permissionsRequired) {
            if (!context.contextState.user_permissions.includes(permission)) {
                history.push(dashboardUrl, { from: location });
                return null;
            }
        }
    }

    const token = window.localStorage.getItem("user_token");
    if (!token) {
        history.push(redirectURl, { from: location });
        return null;
    }

    return (
        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={(props) => <Component {...props} />} />
    );
}
